import { render, staticRenderFns } from "./DevelopmentHistory.vue?vue&type=template&id=7764039c&scoped=true"
import script from "./DevelopmentHistory.vue?vue&type=script&lang=js"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentHistory.vue?vue&type=style&index=0&id=7764039c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7764039c",
  null
  
)

export default component.exports